import React from "react";
import { SingleFieldStep } from "./SingleFieldStep";

interface Props {
  onNextStep: (contactPhone: string) => void;
  onPreviousStep: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  initialValue?: string;
}

export const ContactPhone = ({
  onNextStep,
  onPreviousStep,
  initialValue,
}: Props) => (
  <SingleFieldStep
    titleKey="attraction.onboard.contact_phone.title"
    fieldName="contactPhone"
    labelKey="onboard.contact_phone.label"
    submitLabelKey="onboard.lets_jam"
    dataTestPrefix="onboard.attractionContactPhone"
    inputType="tel"
    onNextStep={onNextStep}
    onPreviousStep={onPreviousStep}
    initialValue={initialValue}
  />
);
